module.exports = __webpack_public_path__ + "img/1F1F1-1F1F0.7a17efb6.svg";